import { httpsCallable } from 'firebase/functions'
import { functions } from '@/firebase'
import { useAuthStore } from '@/store/authStore'
import {
  WORKSPACE_ROTATOR_EXCLUDED_ROLES,
  isWorkspaceRotatorEmail
} from '@/utils/workspaceRoleRotator'
import { clearDebugUserSpoof, waitForJwtRoleClaim } from './authContext.js'

/** Switch the allowlisted demo login to another rotator role in this session. */
export async function rotateDemoRoleInSession(role, scope = {}) {
  const authStore = useAuthStore()
  const email = authStore.currentUser?.email
  if (!isWorkspaceRotatorEmail(email)) {
    throw new Error('Role rotation is only available for the allowlisted demo login.')
  }
  if (WORKSPACE_ROTATOR_EXCLUDED_ROLES.includes(role)) {
    throw new Error('This role is not available on the demo rotator.')
  }

  clearDebugUserSpoof()
  const fn = httpsCallable(functions, 'rotateWorkspaceDemoRole')
  const { data } = await fn({ role, ...scope })
  if (Object.hasOwn(scope, 'allSchools') && data?.scopeProtocol !== 1)
    throw new Error(
      'Deploy the updated rotateWorkspaceDemoRole function before running district scope checks.'
    )
  authStore.mergeCurrentUser({
    role,
    ...(data?.scopeProtocol === 1 ? { allSchools: data.allSchools === true } : {})
  })
  if (!data?.unchanged) {
    await authStore.refreshToken()
  }
  const claimed = await waitForJwtRoleClaim(role, {
    scope: data?.scopeProtocol === 1 ? data : undefined
  })
  if (!claimed) {
    throw new Error(`JWT claim did not become ${role} in time — skipped probes for this role.`)
  }
  return data
}
